module.exports = __webpack_public_path__ + "img/istocneKapijeR.f25e1267.png";